/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'dragon',
    quality: 0.2,
    mana: 1,
    strength: 1
}